import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
  SlideTogglePadraoComponent
} from '../../../shared/components/slide-toggle-padrao/slide-toggle-padrao.component';
import {CanalTemplateEnum} from '../../../shared/enum/canal-template.enum';

@Component({
  selector: 'app-escolha-canal-template',
  standalone: true,
  imports: [
    SlideTogglePadraoComponent
  ],
  templateUrl: './escolha-canal-template.component.html',
  styleUrl: './escolha-canal-template.component.css'
})
export class EscolhaCanalTemplateComponent {

  @Input() canalSelecionado: string = CanalTemplateEnum.WHATSAPP;
  @Input() bloqueado = false;
  @Output() envioCanal = new EventEmitter<string>();

  protected readonly CanalTemplateEnum = CanalTemplateEnum;

  ehWhatsapp(): boolean {
    return (this.canalSelecionado || '').toUpperCase() !== CanalTemplateEnum.SMS;
  }

  selecionarCanal(canal: string): void {
    if (this.bloqueado) return;
    this.canalSelecionado = canal;
    this.envioCanal.emit(canal);
  }
}
